import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ReactTitle } from "react-meta-tags";

import FilterComponent from "../../utils/searchBar";
import { getRoles } from "../../../Redux/reducer/session";
import { moduleAction, loadingHtml } from "../../utils/functions";
import * as ProviderActions from "../../../Redux/actions/providerActions";
import {
  getAllProviders,
  getTotalElements,
} from "../../../Redux/reducer/providers";

//COMPONENTS IMPORTS
import MainTemplate from "../mainTemplate/";
import Modal from "../../utils/customModal";
import BlankClient from "../provider/blankClient";
import TableManagementProvider from "../table/table-management-provider";

//STATIC IMPORTS
import { MOD_PROVID, WRITE } from "../../../permissions";
import plusImage from "../../../../static/images/plus.svg";
import UserAddIco from "../../../../static/images/user-add-grey.svg";
import { useTranslation } from "react-i18next";
import { getFilters } from "../../utils/utilities";

const filters = getFilters([
  { name: "name", property: "provider.institution.name", operator: "eq" },
  {
    name: "identification",
    property: "provider.institution.businessId",
    operator: "eq",
  },
]);

const ProviderPage = ({ history }) => {
  const [state, setState] = useState({
    modal: true,
    componentReady: false,
    page: 0,
    data: null,
    totalSize: 0,
    sizePerPage: 10,
    searchFilters: false,
    filters: [],
    firstLoad: false,
  });

  const { roles, proveedores, totalElements } = useSelector((state) => ({
    roles: getRoles(state),
    proveedores: getAllProviders(state),
    totalElements: getTotalElements(state),
  }));

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { title, addLbl, meta } = t(["providers"], { returnObjects: true });

  useEffect(() => {
    dispatch(ProviderActions.getAllProviders()).then(() =>
      setState((prev) => ({
        ...prev,
        modal: false,
        componentReady: true,
        firstLoad: true,
      }))
    );

    return () => dispatch(ProviderActions.clearProvidersList());
  }, []);

  const search = (searchProperty, searchTerm) => {
    const { page, sizePerPage } = state;
    const actionFilters = [];

    if (!searchTerm) {
      setState((prev) => ({ ...prev, searchFilters: false, filters: [] }));
    } else {
      let newOperator = "";
      filters.map(({ property, operator }) => {
        if (property === searchProperty) newOperator = operator;
      });

      actionFilters.push({
        property: searchProperty,
        operator: newOperator,
        value: searchTerm,
      });

      setState((prev) => ({
        ...prev,
        searchFilters: true,
        filters: actionFilters,
      }));
    }

    dispatch(ProviderActions.getAllProviders(page, sizePerPage, actionFilters));
  };

  const getAllProvidersRef = (page, sizePerPage, currentFilters) =>
    dispatch(
      ProviderActions.getAllProviders(page, sizePerPage, currentFilters)
    );

  const renderProviderTable = () => {
    const { page, sizePerPage, firstLoad, filters, searchFilters } = state;

    if (searchFilters || (firstLoad === true && proveedores?.length)) {
      return (
        <TableManagementProvider
          page={page}
          data={proveedores}
          filters={filters}
          history={history}
          totalSize={totalElements}
          sizePerPage={sizePerPage}
          getAllProviders={getAllProvidersRef}
        />
      );
    }
    return <BlankClient />;
  };

  return (
    <MainTemplate>
      <ReactTitle title={`${meta.title} - Reverse Factoring`} />
      <div className="header-title flex-element">
        <div className="title gest-client flex-element">
          <img src={UserAddIco} />
          <div className="client-gest">{title}</div>
        </div>
        <div className="actions flex-element">
          {moduleAction(roles, MOD_PROVID, WRITE) && (
            <Link
              to="/bscadministrator/providers/add"
              className="add-button flex-element"
            >
              <p className="bsc-add-client">{addLbl}</p>
              <img src={plusImage} />
            </Link>
          )}
          <div className="filter">
            <FilterComponent filter={filters} searchFnc={search} />
          </div>
        </div>
      </div>
      {state.componentReady ? renderProviderTable() : null}
      <Modal show={state.modal}>{loadingHtml()}</Modal>
    </MainTemplate>
  );
};

export default ProviderPage;
